








































import { UserModule } from "@/store/user";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class NavMenu extends Vue {
  @Prop() readonly menu: any;

  canAccess(validate: boolean): boolean {
    return validate ? UserModule.isAdmin : true;
  }

  navigate(to: string): void {
    this.$router.push({ name: to }).catch(() => {
      null;
    });
  }
}
